export default __webpack_public_path__ + "static/media/australian_payments_network_logo.9aaffc6a.png";